import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid place-items-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "bg-white border html-container w-[1200px] h-[600px] overflow-scroll"
}
const _hoisted_4 = ["data"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Error: The render cannot be displayed.", -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_w_spinner = _resolveComponent("w-spinner")!
  const _component_w_alert_description = _resolveComponent("w-alert-description")!
  const _component_w_alert = _resolveComponent("w-alert")!
  const _component_w_dialog = _resolveComponent("w-dialog")!

  return (_openBlock(), _createBlock(_component_w_dialog, {
    class: "overflow-y-auto bg-primaryGrapesJs-900",
    title: _ctx.isRendering ? 'Rendering...' : _ctx.errorMessage ? 'Error' : _ctx.render ? _ctx.render.subject : 'Untitled*',
    showCloseButton: "",
    persistent: ""
  }, {
    default: _withCtx(() => [
      (_ctx.isRendering)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_w_spinner, { small: "" })
          ]))
        : (!_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.docType == 'email' || _ctx.docType == 'form')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                : _createCommentVNode("", true),
              (_ctx.docType == 'document')
                ? (_openBlock(), _createElementBlock("object", {
                    key: 1,
                    class: "bg-white",
                    data: _ctx.fullString,
                    type: "application/pdf",
                    width: "1200",
                    height: "600"
                  }, _hoisted_6, 8, _hoisted_4))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
      (_ctx.errorMessage)
        ? (_openBlock(), _createBlock(_component_w_alert, {
            key: 2,
            mode: "error"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_w_alert_description, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}